import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

export const content = (theme: Theme) => css`
  li + li {
    margin-top: 0.25em;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  dl,
  ol,
  ul,
  blockquote,
  pre,
  table {
    color: ${theme.text.body};
  }

  p,
  dl,
  ol,
  ul,
  blockquote,
  pre,
  table {
    &:not(:last-child) {
      margin-bottom: 1em;
    }
  }

  h1 {
    font-size: ${theme.aviaryTypography.h1.fontSize};
  }
  h2 {
    font-size: ${theme.aviaryTypography.h2.fontSize};
  }
  h3 {
    font-size: ${theme.aviaryTypography.h3.fontSize};
  }
  h4 {
    font-size: ${theme.aviaryTypography.h4.fontSize};
  }
  h5 {
    font-size: ${theme.aviaryTypography.h5.fontSize};
  }
  p {
    font-size: ${theme.aviaryTypography.body.fontSize};
  }

  a {
    color: ${theme.success.textBase};
    text-decoration: underline;

    &:hover {
      color: ${theme.success.textHover};
    }
    &:active {
      color: ${theme.success.textActive};
    }
  }
  strong {
    font-weight: ${typography.weightBold};
  }

  ol {
    list-style-position: outside;
    margin-left: 2em;
    margin-top: 1em;
  }
  ul {
    list-style: disc outside;
    margin-left: 2em;
    margin-top: 1em;
    ul {
      list-style-type: circle;
      margin-top: 0.5em;
      ul {
        list-style-type: square;
      }
    }
  }
  dd {
    margin-left: 2em;
  }
  figure {
    margin-left: 2em;
    margin-right: 2em;
    text-align: center;
    &:not(:first-of-type) {
      margin-top: 2em;
    }
    &:not(:last-child) {
      margin-bottom: 2em;
    }
    img {
      display: inline-block;
    }
    figcaption {
      font-style: italic;
    }
  }
  pre {
    overflow-x: auto;
    padding: 1.25rem 1.5rem;
    white-space: pre;
    word-wrap: normal;
  }
  sup,
  sub {
    font-size: 75%;
  }
`;

export const centered = css`
  text-align: center;
`;
